import { createSSRApp } from 'vue';
import { createPinia } from 'pinia';
import '@garmin/components-global-vue-styles/dist/baseStyles.css';
import App from './App.vue';
import { createAppRouter } from './router/router.js';

/**
 * Creates and configures the Vue application instance
 * @param {boolean} isSSR - whether the app is being created for server-side rendering (SSR)
 * @returns {{ app: import('vue').App,
 * router: import('vue-router').Router,
 * pinia: import('pinia').Pinia }} - an object containing the Vue app instance, the router, and the Pinia store instance.
 */
export async function createApp(isSSR = false) {
  const app = createSSRApp(App);
  const pinia = createPinia();
  const router = await createAppRouter(isSSR);

  app.use(router);
  app.use(pinia);

  app.config.compilerOptions.whitespace = 'preserve';

  return { app, router, pinia };
}

export default createApp;
